import React from 'react';
import { Flex, Typography } from '../../exports';

/**
 * NackleBehavior component displays a behavior with an optional image and name
 * @param {Object} props - Component props
 * @param {string} [props.size] - Size variant ('large', 'small', 'medium', 'jumbo')
 * @param {string} [props.imageURL] - URL of the behavior image
 * @param {string} props.name - Name of the behavior
 * @returns {JSX.Element} NackleBehavior component
 */
const NackleBehavior = ( props ) => {

    /**
     * Determines CSS class names based on size prop
     * @returns {string} Space-separated class names
     */
    const getClassNames = () => {
        if ( props.size === 'large' ) {
            return 'nackle-behavior nackle-behavior-large';
        }
        if ( props.size === 'small' ) {
            return 'nackle-behavior nackle-behavior-small';
        }
        if ( props.size === 'jumbo' ) {
            return 'nackle-behavior nackle-behavior-jumbo';
        }

        else {
            return 'nackle-behavior';
        }
    };

    return (
        <Flex className={ getClassNames() }>
            { props.imageURL &&
                <img src={ `${ props.imageURL }?width=144` } alt={ `${ props.name } behavior` }></img>
            }
            <Typography.Text className="behavior-name">{ props.name }</Typography.Text>
        </Flex>
    );
};

export { NackleBehavior };
